import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const BankIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Bank",
    children: /*#__PURE__*/_jsx("path", {
      d: "M4.12 27.13h23.75c.53 0 .96.43.96.96v.95c0 .53-.43.96-.96.96H4.12a.96.96 0 0 1-.96-.96v-.95c0-.53.43-.96.96-.96m.87-14.76h22.03c.65 0 1.16-.53 1.16-1.18 0-.3-.12-.59-.33-.81L16.77 2.35a1.15 1.15 0 0 0-1.62-.02l-.02.02-10.97 8.04c-.45.45-.45 1.19 0 1.64.22.22.51.34.82.34Zm4.87 1.29H8.17a.67.67 0 0 0-.68.66v9.24H5.8c-.41 0-.74.32-.74.72V25c0 .41.33.74.74.74h20.39c.41 0 .74-.33.74-.74v-.71c0-.41-.33-.73-.73-.73h-1.7v-9.19a.67.67 0 0 0-.66-.68H22.2a.67.67 0 0 0-.68.66v9.24h-4v-9.22a.67.67 0 0 0-.66-.68h-1.7a.67.67 0 0 0-.68.66v9.24h-3.95v-9.22a.67.67 0 0 0-.63-.71z"
    })
  }));
};